import { Helmet } from 'react-helmet-async';

const defaultMeta = {
  title: 'StatusBot - AI-Powered Operations',
  description: 'Supercharge your project management with AI-powered insights and seamless team collaboration.',
  image: 'https://status.bot/status-bot-og.png',
  url: 'https://status.bot',
};

export const SEO = ({ 
  title, 
  description, 
  image = defaultMeta.image,
  url = defaultMeta.url,
  children 
}) => {
  const siteTitle = title ? title : defaultMeta.title;

  return (
    <Helmet>
      {/* Basic */}
      <title>{siteTitle}</title>
      <meta name="description" content={description || defaultMeta.description} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={description || defaultMeta.description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={siteTitle} />
      <meta name="twitter:description" content={description || defaultMeta.description} />
      <meta name="twitter:image" content={image} />

      {/* Additional meta tags */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <link rel="canonical" href={url} />

      {children}
    </Helmet>
  );
}; 